import React, { useState, useRef, useEffect } from 'react';
import './OrderNowSection.css';

const initialLocations = [
  { name: 'Frisco', img: '/assets/location.png' },
  { name: 'Euless', img: '/assets/location.png' },
  { name: 'Irving', img: '/assets/location.png' },
];

const OrderNowSection = () => {
  const [locations, setLocations] = useState(
    initialLocations.map((loc) => ({ ...loc, active: loc.name === 'Euless' }))
  );
  const cardsRef = useRef(null);



  // Force Euless to be active on mount
  useEffect(() => {
    setLocations(prev => prev.map(loc => ({ ...loc, active: loc.name === 'Euless' })));
  }, []);

  // Effect for centering the active card on initial load (mobile only)
  useEffect(() => {
    if (window.innerWidth > 900) return;
    const container = cardsRef.current;
    if (!container) return;
    const activeCard = container.querySelector('.order-card.active');
    if (activeCard) {
      const containerWidth = container.offsetWidth;
      const cardWidth = activeCard.offsetWidth;
      const cardLeft = activeCard.offsetLeft;
      const scrollLeft = cardLeft - containerWidth / 2 + cardWidth / 2;
      container.scrollTo({ left: scrollLeft, behavior: 'auto' });
    }
  }, []);

  // Effect for updating the active card on scroll (mobile only)
  useEffect(() => {
    if (window.innerWidth > 900) {
      // On desktop, always keep Euless active
      setLocations((prev) => prev.map((loc) => ({ ...loc, active: loc.name === 'Euless' })));
      return;
    }
    
    const container = cardsRef.current;
    if (!container) return;
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const cardName = entry.target.getAttribute('data-name');
            setLocations((prevLocations) =>
              prevLocations.map((loc) => ({ ...loc, active: loc.name === cardName }))
            );
          }
        });
      },
      { root: container, threshold: 0.6 }
    );
    
    const cards = container.querySelectorAll('.order-card');
    cards.forEach((card) => observer.observe(card));
    
    return () => {
      cards.forEach((card) => observer.unobserve(card));
    };
  }, []); // Removed locations dependency to prevent infinite loop

  return (
    <section className="order-now-section"  style={{ backgroundImage: `url(${process.env.PUBLIC_URL + '/assets/lbg.png'})` }}>
      <h2 className="order-now-title">Order Now</h2>
      <div className="order-now-cards" ref={cardsRef}>
        {locations.map((loc) => (
          <div
            className={`order-card${loc.active ? ' active' : ''}`}
            key={loc.name}
            data-name={loc.name}
          >
            <img src={process.env.PUBLIC_URL + loc.img} alt={loc.name} className="order-card-logo" />
            <div className="order-card-pin">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="20" cy="20" r="20" fill={loc.active ? '#FF6A00' : '#BDBDBD'} />
                <path d="M20 12C16.6863 12 14 14.6863 14 18C14 22.25 20 28 20 28C20 28 26 22.25 26 18C26 14.6863 23.3137 12 20 12ZM20 20C18.8954 20 18 19.1046 18 18C18 16.8954 18.8954 16 20 16C21.1046 16 22 16.8954 22 18C22 19.1046 21.1046 20 20 20Z" fill="white"/>
              </svg>
            </div>
            <div className="order-card-location">{loc.name}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OrderNowSection; 